// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleButton_container__hMYB1"};